import React from 'react';
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import { computeAssemblySelfComparison } from '../components/tsrComparisonUtils';

const AssemblySelfComparisonSection = ({ timeSinceRecords }) => {
  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h6">As compared to This Assembly Itself</Typography>
      </Box>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell sx={{ minWidth: 200 }}>Label</TableCell>
              <TableCell>Unit</TableCell>
              <TableCell>Installed At Assembly Value</TableCell>
              <TableCell>Due At Assembly Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {timeSinceRecords && timeSinceRecords.length > 0 ? (
              timeSinceRecords.map((record, index) => {
                const comparison = computeAssemblySelfComparison(record);
                const unit =
                  record.elapsedTime?.unit ||
                  record.limit?.unit ||
                  record.remainingTime?.unit ||
                  record.installedValue?.unit ||
                  '';
                return (
                  <TableRow key={index}>
                    <TableCell>{record.type}</TableCell>
                    <TableCell>{record.label}</TableCell>
                    <TableCell>{unit}</TableCell>
                    <TableCell>
                      {comparison.installedAtComponent != null && comparison.installedAtComponent !== ''
                        ? comparison.installedAtComponent
                        : 'N/A'}
                    </TableCell>
                    <TableCell>
                      {comparison.dueAtComponent != null && comparison.dueAtComponent !== ''
                        ? comparison.dueAtComponent
                        : 'N/A'}
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  Add Time Since Records to see assembly self-comparisons here.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default AssemblySelfComparisonSection;
